//PrimeReact
import { Dropdown } from "primereact/dropdown"
import { RadioButton } from "primereact/radiobutton"

//Appointments modules
import styles from "../../styles/appointments/AppointmentsCron.module.css"

//Utils
import { getNumberRange } from "./utils"

export default function AppointmentsFormCronDaily({
  dailyType,
  dailyNDays,
  onSetDailyType,
  onSetDailyNDays,
}) {
  return (
    <>
      <div>Daily options: </div>
      <div className={styles.cronOption}>
        <RadioButton
          value={"nDays"}
          onChange={(e) => {
            onSetDailyType(e.value)
          }}
          checked={dailyType === "nDays"}
          className={styles.cronOptionRadioButton}
        />
        <span className={styles.cronOptionPortion}>Every </span>
        <Dropdown
          options={getNumberRange(1, 7)}
          value={dailyNDays}
          onChange={(e) => {
            onSetDailyNDays(e.value)
            if (dailyType !== "nDays") {
              onSetDailyType("nDays")
            }
          }}
          className={styles.cronOptionPortion}
        />
        <span> day(s)</span>
      </div>
      <div className={styles.cronOption}>
        <RadioButton
          value={"weekDays"}
          onChange={(e) => {
            onSetDailyType(e.value)
          }}
          checked={dailyType === "weekDays"}
          className={styles.cronOptionRadioButton}
        />
        <span>Every week day</span>
      </div>
    </>
  )
}
